<app-mu-section-title title="context.massive.newRouting.breadcrumb.title" subTitle="context.massive.newRouting.breadcrumb.subtitle"></app-mu-section-title>
<app-massive-deliveries-table
  id="ctx-masivos-deliveries-table"
  [flags]="flags"
  [tableListColumns]="deliveriesTableColumns"
  [dataList]="deliveriesDataList"
  [filters]="deliveriesFilters"
  [filterFields]="deliveriesFilterFields" 
  [tableOptionListEdition]="tableOptionList"
  [actionsEdition]="deliveriesActions"
  [formData]="formData"
  [localityList]="localityList"
  [weightList]="sizeList"
  [breadCrumbItems]="breadCrumbItems"
  [markers]="markers"
  (rowSelectionEvent)="servicesSelection($event)"
>
</app-massive-deliveries-table>

<app-mu-modal-dialog-layout
  [hideLine]="true"
  [showFlag]="massiveServiceFlags.SHOW_LOAD_FILE"
  [flagList]="flags"
  [showCloseIcon]="true"
  (eventCloseDialogModal)="cancelFileForm(fileUploadform)"
  (eventCancelAction)="cancelFileForm(fileUploadform)"
  [bigContent]="true"
>
  <div modalDialogContent class="mu-full-width">
    <div class="modal-dialog-header" [ngClass]="{'mu-color-purpleMedium': !this.fileLoaded, 'mu-color-colorBlueMU': this.fileLoaded}">
      <i id="upload-icon-lg" class="fas fa-upload mu-large-icon" aria-hidden="true"></i>
      <h3 id="modal-dialog-content-title">{{'context.massive.fileUploadForm.title' | translate}} <i id="icon-information" class="fas fa-info-circle" aria-hidden="true"></i></h3>
    </div>
    <app-file-upload-deliveries-form #fileUploadform 
      [formData]="fileFormData"
      [flagList]="flags"
      [fileUploadedFlag]="massiveServiceFlags.FILE_LOADED"
      [uploadFileFlag]="massiveServiceFlags.UPLOAD_FILE"
      [fileFormatsAllowedToUpload]="fileFormatsAllowedToUpload"
      [modalFlag]="massiveServiceFlags.SHOW_LOAD_FILE"
      >
    </app-file-upload-deliveries-form>
  </div>
</app-mu-modal-dialog-layout>

<app-mu-modal-dialog-layout 
    id="modalDialogLayoutError"
    [hideLine]="true"
    [flagList]="flags"
    [showCloseIcon]="true"
    [showFlag]="massiveServiceFlags.SHOW_ERROR_MODAL"
    (eventCloseDialogModal)="cancelFileForm(fileUploadform)">
    >
    <div modalDialogContent class="">
        <i id="times-circle-icon-lg" class="fas fa-times-circle mu-red-icon" aria-hidden="true"></i>
        <div>
            <h3>
                {{'context.massive.errorModal.error' | translate}}
            </h3>
            <br>
            <h3>
                {{this.errorMessage}}
            </h3>
            <br>
            <h3>
                {{'context.massive.errorModal.tryAgain' | translate}}
            </h3>
        </div>
    </div>
</app-mu-modal-dialog-layout>
